import moment from 'moment';

export const FILTER_KEYS = ['institution_id', 'classroom_id', 'student', 'role', 'flagged', 'outcome', 'intent', 'section', 'prompt_kind', 'path'];

export const SAMPLE_OPTIONS = [50, 100, 250, 500];

export const defaultPeriod = () => ({
  from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
  to: moment().format('YYYY-MM-DD')
});

// URLSearchParams → objeto de filtros aplicados (a URL é a fonte da verdade, para o link poder ser compartilhado).
export function readFilters(searchParams) {
  const period = defaultPeriod();
  const filters = { from: searchParams.get('from') || period.from, to: searchParams.get('to') || period.to, sample: searchParams.get('sample') || '100' };
  FILTER_KEYS.forEach(key => {
    const value = searchParams.get(key);
    if (value) filters[key] = value;
  });
  return filters;
}

// Parâmetros enviados à API (vazios saem; `role=all` é o padrão da API).
export function toQuery(filters) {
  const entries = Object.entries(filters).filter(([key, value]) => value !== undefined && value !== null && value !== '' && !(key === 'role' && value === 'all'));
  return Object.fromEntries(entries);
}
